export default __webpack_public_path__ + "static/media/left-arrow.e974c949.svg";